(() => {
  function init(root=document) {
    root.querySelectorAll('[data-breath-section]').forEach(section => {
      if(section.dataset.initialized) return;
      section.dataset.initialized='true';
      const main=section.querySelector('[data-gallery-main] img');
      section.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>{
        main.srcset=button.dataset.srcset;main.src=button.dataset.src;main.alt=button.dataset.alt;
        section.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        button.scrollIntoView({block:'nearest',inline:'nearest'});
      }));
      const sticky=section.querySelector('[data-sticky]');
      const buy=section.querySelector('.br-buy');
      if(sticky && buy && 'IntersectionObserver' in window){
        const observer=new IntersectionObserver(entries=>{const e=entries[0];sticky.hidden=e.isIntersecting || e.boundingClientRect.bottom>0;},{threshold:0});
        observer.observe(buy);
        section._breathObserver=observer;
      }
      const variants=section.querySelector('[data-variant]');
      if(variants) variants.addEventListener('change',()=>{
        const choice=variants.selectedOptions[0];
        section.querySelector('.br-price').textContent=choice.dataset.price;
        const button=section.querySelector('button[name=add]');button.disabled=choice.dataset.available!=='true';
        button.textContent=button.disabled?'Sold out':'Add to bag ↗';
        section.querySelectorAll('[data-sticky-price]').forEach(x=>x.textContent=choice.dataset.price);
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:block:select',event=>{event.target.closest('[data-image]')?.click();});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-breath-section]').forEach(s=>s._breathObserver?.disconnect()));
})();
